module.exports = __webpack_public_path__ + "img/wlwyypt_banner.c07d2bfa.png";